import * as sup from "superstruct";

import { achievementResourceStruct } from "@/modules/achievements/api/achievementResourceStruct";
import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { groupItemResourceStruct } from "@/modules/groups/api/resources/groupsResourceStruct";

import { getUserResourcePath } from "../resources/userResourceConsts";
import { userResourceStruct } from "../resources/userResourceStruct";

export const getUserQuery = (
  jsonApi: JsonApiClient,
  { companyId, userId }: { companyId: string; userId: string }
) => {
  return () =>
    jsonApi.getOne({
      path: getUserResourcePath({ companyId, userId }),
      responseStruct: getUserResponseStruct,
    });
};

const getUserResponseStruct = createResponseStruct({
  data: userResourceStruct,
  included: sup.array(
    sup.union([achievementResourceStruct, groupItemResourceStruct])
  ),
});

export type GetUserResponse = sup.Infer<typeof getUserResponseStruct>;
